import React from 'react';
import { AgCampaign } from '@indigo-ag/schema';

import i18next from 'core/i18n';
import { NewPage } from 'core/components';
import { AddNewCampaign } from '../../components/AddNewCampaign/AddNewCampaign';
import { CampaignsList } from '../../components/CampaignsList/CampaignsList';
import { allCampaigns } from 'features/admin/adminQueries';
import { LoadingWrapper } from 'shared';

export const CampaignsPage: React.FunctionComponent = () => {
  return (
    <NewPage title={i18next.t('campaigns')}>
      <AddNewCampaign />
      <LoadingWrapper query={allCampaigns}>
        {({ data }: { data: { financingCampaigns: AgCampaign[] } }) => {
          return <CampaignsList campaigns={data.financingCampaigns} />;
        }}
      </LoadingWrapper>
    </NewPage>
  );
};
